import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ForgotPassForm from '../components/forgot-pass/forgot-pass-form';
import { useTranslation } from 'react-i18next';
import LogoComponent from '../components/logo-comp';
import PageBackground from '../components/background-component';

const ForgotPass = () => {
    const { t } = useTranslation();
    return (
        <div className="pg-form pg-forgot-pass page-bg">
            <div className="page-wrapper">
                <PageBackground
                    desktop={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-login.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-login.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-login.jpg`
                    }}
                    mobile={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-login.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-login.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-login.jpg`
                    }}
                />
                <Row className="mb-3">
                    <Col md="12" className="margin-0">
                        <div className='bl-form bl-form-bg'>
                            <LogoComponent logoColor="white" />
                            <h1>{t('forms.forgotPass')}</h1>
                            <ForgotPassForm />
                            {/* <SocialAuthButtons onSuccess={handleSocialSuccess} onError={handleSocialError} /> */}
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default ForgotPass;